import React from 'react'
import Action from 'store/Action'
import { IAppState } from 'App'
import {
  initialScreen,
  initialQuestions,
  initialResponses,
  initialResult,
  initialUi,
  initialProducts,
} from './reducers'

export const StateContext = React.createContext<IAppState>({
  ui: initialUi,
  screen: initialScreen,
  questions: initialQuestions,
  products: initialProducts,
  responses: initialResponses,
  result: initialResult,
})

export const DispatchContext = React.createContext((action: Action<any>) => {
  return
})
